(function () {
  function initTakuroaRing() {
    var root = document.getElementById('TakuroaRingAdvertorial');
    var sticky = document.getElementById('takuroa-ring-sticky');
    if (!root || !sticky) return;

    var hero = root.querySelector('.hero');
    var offer = document.getElementById('takuroa-offer');

    function updateSticky() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var heroEnd = hero ? hero.offsetTop + hero.offsetHeight : 600;
      var reachedOffer = offer ? offer.getBoundingClientRect().top < window.innerHeight : false;
      sticky.classList.toggle('on', scrollTop > heroEnd && !reachedOffer);
    }

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    updateSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTakuroaRing);
  } else {
    initTakuroaRing();
  }
})();
